// 페이지 목록의 산수 — 몇 쪽이 있고 지금 몇 쪽인지만 알면 정해진다.
//
// 끝의 두 쪽과 지금 쪽 둘레는 늘 보인다: 처음과 끝은 목록의 크기를 말하고
// 둘레는 다음에 누를 곳이다. 그 사이는 접는다.

export type PageItem = number | 'gap'

/** 지금 쪽 양옆으로 늘 보이는 쪽 수. */
const AROUND = 2

/** 접지 않고 다 보일 수 있는 쪽 수 — 접은 자리가 쪽보다 넓어지지 않는 선이다. */
const FLAT = 2 * AROUND + 5

/**
 * 그릴 쪽 번호와 접은 자리를 차례로 준다.
 * `page` 는 1부터이고 범위를 벗어나면 가까운 끝으로 당긴다.
 */
export function pageItems(page: number, pages: number): PageItem[] {
  const last = Math.max(1, Math.trunc(pages))
  const here = Math.min(Math.max(1, Math.trunc(page)), last)
  if (last <= FLAT) return range(1, last)

  const from = Math.max(2, here - AROUND)
  const to = Math.min(last - 1, here + AROUND)
  const items: PageItem[] = [1]
  // 접은 자리가 쪽 하나만 감추면 그 쪽을 그대로 보인다 — `…` 가 더 넓다.
  if (from > 3) items.push('gap')
  else if (from === 3) items.push(2)
  items.push(...range(from, to))
  if (to < last - 2) items.push('gap')
  else if (to === last - 2) items.push(last - 1)
  items.push(last)
  return items
}

function range(from: number, to: number): number[] {
  const out: number[] = []
  for (let n = from; n <= to; n += 1) out.push(n)
  return out
}
